import Link from 'next/link';
import PropTypes from 'prop-types';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import styles from './twoColumnLayoutLP.module.scss';
import AccordionWrapper from '../accordion/accordionWrapper';

export default function TwoColumnLayoutLP({ items = [] }) {
  const { width } = useWindowDimensions();
  const renderListChildItems = (childItems) => {
    return (
      <ul className={styles.accordionChild}>
        {childItems?.map((childItem) => (
          <li className={styles.accordionChildItem} key={childItem?.label}>
            <Link href={childItem?.link} data-testid={childItem?.label}>
              {childItem?.label}
            </Link>
          </li>
        ))}
      </ul>
    );
  };
  return (
    <div>
      {width < 1024
        ? items?.map((item, index) => (
            <AccordionWrapper
              /* eslint-disable-next-line react/no-array-index-key */
              key={`panel-${index}`}
              id={`panel-${index}`}
              head={item?.title}
              body={renderListChildItems(item?.childItems)}
              borderTopHidden={index === 0}
            />
          ))
        : items?.map((item) => (
            <div key={`rawData${item?.title}`}>
              <h5 className={styles.sectionTitle}>{item?.title}</h5>
              <ul className={styles.cardGrid}>
                {item?.childItems?.map((childItem) => (
                  <li className={styles.cardGridItem} key={childItem?.label}>
                    <Link href={childItem?.link} data-testid={childItem?.label}>
                      {childItem?.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
    </div>
  );
}

TwoColumnLayoutLP.propTypes = {
  items: PropTypes.array,
};
